exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-new {\r\n  float: right;\r\n  display: inline-block;\r\n  height: 29px;\r\n  line-height: 9px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.label-class {\r\n  font-weight: 600;\r\n  padding: 5px 10px;\r\n  display: inline-block;\r\n  background-color: #fff;\r\n  border-radius: 4px;\r\n}\r\n\r\n.selected {\r\n  font-weight: 600;\r\n  padding: 5px;\r\n  display: inline-block;\r\n  background-color: #00a65a;\r\n  margin-right: 5px;\r\n  border-radius: 100%;\r\n}\r\n\r\n.bg-primary {\r\n  background-color: #3c8dbc;\r\n  border-color: #367fa9;\r\n}\r\n\r\n.nav.nav-stacked.classes li {\r\n  margin-top: 0;\r\n  display: inline-block;\r\n  float: left;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/provider-characteristic/provider-characteristic.component.css
// module id = ../../../../../src/app/main/pages/provider-characteristic/provider-characteristic.component.css
// module chunks = main